module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_j_albino.96c41ce7.png";